import GeneralSettingsHandler from './GeneralSettingsHandler'
import getAppConfig from './gql/getAppConfig'

export default {
	label: 'Betrieb',
	link: '',
	exact: true,
	typename: 'AppConfig',
	subsections: [],
	itemQuery: getAppConfig,
	handler: GeneralSettingsHandler
}

